<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>엑셀 업로드</h3>
        </CRow>
        <CRow>
            <CCol sm="12">
                <div class="card" style="max-height: 340px;">
                    <div class="card-body">
                        <div bordered="true" small="true">
                            <div class="position-relative table-responsive" style="max-height: 300px;">
                                <b-table
                                        id = "list-table"
                                        :items="items"
                                        :fields="fields"
                                        striped hover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="5">
                <CCard>
                    <CCardHeader textColor="primary">
                        {{regTypeTxt}}
                    </CCardHeader>
                    <CCardBody v-html="regTypeBody" textColor="danger">
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol sm="7">
                <CCard>
                    <CCardHeader>
                        <div role="group" class="form-check">
                            <input id="sendSmsCheck" type="checkbox" class="form-check-input" value="알림메시지 전송" v-model="checked">
                            <label for="sendSmsCheck" style="font-size: medium; margin-bottom: 0px;">청구내역이 있을 경우 알림메시지로 전송합니다.</label>
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <div>
                            <textarea v-model="smsData" rows="3" style="width: 100%;border: 1px solid #d3d3d3;">
                            </textarea>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol class="btn-col-margin ml-8" sm="1">
                <button label=""
                        type="button"
                        class="btn btn-info btn-block"
                        @click="goUploadProc">
                    등 록
                </button>
            </CCol>
            <CCol class="btn-col-margin ml-8" sm="1">
                <button label=""
                        type="button"
                        class="btn btn-info btn-block"
                        @click="back">닫 기
                </button>
            </CCol>
        </CRow>
    </div>
</template>
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/css/bootstrap.min.css" />
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
    .radiotext {
        margin: 10px 10px 0px 0px;
    }
</style>
<script>
    import axios from 'axios'

    export default {
        name: 'PayManageExcelUpload',
        components: {},
        data: function() {
            return {
                items: this.$route.params.dataArray,
                fields: [
                    {
                        label: '이름',
                        sortable: true
                    },
                    {
                        label: '진료번호',
                        sortable: true
                    },
                    {
                        label: '주민번호',
                        sortable: true
                    },
                    {
                        label: '상태',
                        sortable: true
                    },
                    {
                        label: '입원일',
                        sortable: true
                    },
                    {
                        label: '퇴원일',
                        sortable: true
                    },
                    {
                        label: '청구액',
                        sortable: true
                    }
                ],
                regType: "",
                regTypeTxt: "",
                regTypeBody: "",
                checked: false,
                //smsData: "요양병원입니다. 이번달 결제일은 25일이며, {환자명} 님의 결제액은 {청구액} 원 입니다. 등록하신 앱에서 편리하게 분할로 결제하실수 있습니다."
                smsData: "안녕하십니까? 병원입니다. 이번달 청구금액이 있습니다. 등록하신 앱에서 금액확인 및 결제가 가능합니다. "
            };
        },
        mounted() {
            const regType = this.$route.params.regType;
            if (regType == "P") {
                this.regType = regType;
                this.regTypeTxt = "환자정보 일괄 등록";
                this.regTypeBody = "- 기존 환자 정보는 그대로 유지하고 입력한 환자 정보만 등록(또는 갱신)합니다." +
                    "<br/>- 청구액이 있는 경우 금액을 추가로 청구합니다.";
            } else if (regType == "A") {
                this.regType = regType;
                this.regTypeTxt = "청구금액 일괄 등록";
                this.regTypeBody = "- 청구액이 있는 경우 금액을 추가로 청구합니다.";
                /*
                                this.regTypeBody = "- 모든 환자 정보를 새로운 정보로 변경합니다." +
                                    "<br/>- 엑셀 파일에 없는 환자는 모두 퇴원 처리됩니다" +
                                    "<br/>- 청구액이 있는 경우 금액을 추가로 청구합니다.";
                */
            }

            //병원정보 호출
            axios.get('silver/getCompany')
                .then(res => {
                    console.log(res);
                    if (res.data != null){
                        this.smsData = '안녕하십니까? '+res.data.name+'병원입니다. 이번달 청구금액이 있습니다. 등록하신 앱에서 금액확인 및 결제가 가능합니다.'
                    }
                }).catch(error => {
                    console.log(error);
            });
        },
        methods: {
            shuffleArray(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    let j = Math.floor(Math.random() * (i + 1));
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                }
                return array;
            },
            getShuffledUsersData() {
                return this.shuffleArray(usersData.slice(0));
            },
            back() {
                this.$router.push({name:"paymanagementlist"})
            },
            goUploadProc() {
                if (this.checked) {
                    if (this.smsData === undefined || this.smsData.trim() == "") {
                        alert("알림 메시지 내용을 입력하세요!");
                        return;
                    }
                }

                const qs = require('querystring');
                const formData = qs.stringify({
                    'regType': this.regType
                    , 'smsCheck': this.checked
                    , 'smsMsg': this.smsData
                    , 'custData': JSON.stringify(this.items)
                });

                axios.post('silver/cust/uploadCustListExcel', formData)
                    .then(res => {
                        if (res.data.dupleList != null){
                            alert("중복된 진료번호를 제외한 등록이 완료되었습니다.\n중복된 진료번호 :"+res.data.dupleList);
                        } else {
                            alert("등록되었습니다");
                        }
                        this.$router.replace({name: 'paymanagementlist'});
                    }).catch(error => {
                    console.log(error);
                });
            }
        }
    }
</script>
